import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import TaskTemplate from "@/components/html/extensions/components/TaskTemplate.vue";

export default Node.create({
  name: 'task',

  group: 'inline',
  
  inline: true,

  selectable: true,
  
  atom: true,

  draggable: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      name: {
        default: null,
      },
      url: {
        default: null,
      },
      isDraggable: {
        default: true,
        renderHTML: (attributes) => {
          return {};
        }
      },
      inline: {
        default: false,
      },
    }
  },

  parseHTML() {
    return [{
      tag: 'task',
    }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['task', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(TaskTemplate);
  },

  addCommands() {
    return {
      setTask: (options) => ({ tr, dispatch }) => {
        const { selection } = tr
        const node = this.type.create(options)

        if (dispatch) {
          tr.replaceRangeWith(selection.from, selection.to, node)
        }

        return true
      },
      toggleTask: () => ({ commands }) => {
        return commands.toggleWrap(this.name)
      },
      unsetTask: () => ({ commands }) => {
        return commands.lift(this.name)
      },
    }
  }
});
